/*
 * Scripts personnalisés du thème, extraits de layout/theme.liquid.
 * Ils étaient écrits en dur dans chaque page HTML : sortis en asset, ils sont
 * téléchargés une seule fois puis servis depuis le cache du navigateur.
 */

/* ── Variantes liées : vignettes injectées sous la fiche ────────────────── */
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product-variants").forEach(function (variantContainer) {
    let variantIds = variantContainer.dataset.variantIds;

    if (variantIds) {
      let idsArray = variantIds.split(",").map(id => id.trim()).filter(id => id && !isNaN(id));

      console.log("Produits liés trouvés :", idsArray); // Vérification console

      idsArray.forEach(function (variantId) {
        if (!variantId || variantId.trim() === "") return;

        fetch(`/products/${variantId}.json`)
          .then(response => {
            if (!response.ok) throw new Error(`Produit introuvable : ${variantId}`);
            return response.json();
          })
          .then(data => {
            if (data.product) {
              let product = data.product;
              let imgSrc = product.images.length > 0 ? product.images[0].src : null;

              if (imgSrc) {
                let variantLink = document.createElement("a");
                variantLink.href = product.url;
                variantLink.className = "variant-image";

                let variantImg = document.createElement("img");
                variantImg.src = imgSrc;
                variantImg.alt = product.title;
                variantImg.title = product.title;
                variantImg.style.width = "40px";
                variantImg.style.height = "40px";
                variantImg.style.borderRadius = "5px";
                variantImg.style.border = "1px solid #ddd";
                variantImg.style.marginRight = "5px";
                variantImg.style.transition = "transform 0.2s ease-in-out";

                variantImg.addEventListener("mouseover", function () {
                  variantImg.style.transform = "scale(1.1)";
                });

                variantImg.addEventListener("mouseout", function () {
                  variantImg.style.transform = "scale(1)";
                });

                variantLink.appendChild(variantImg);
                variantContainer.appendChild(variantLink);
              }
            }
          })
          .catch(error => console.error("Erreur de chargement du produit :", error));
      });
    }
  });
});

/* ── Nuancier de coloris sur les cartes produit (.ms-col-swatch) ─────────── */
document.querySelectorAll(".ms-col-swatch a").forEach(function (element) {
        element.addEventListener("click", function (event) {
          event.preventDefault();
          let title = this.getAttribute("data-tmp-title");
          let firstPhoto = this.getAttribute("data-tmp-first-photo");
          let secondPhoto = this.getAttribute("data-tmp-second-photo");
          let productURL = this.getAttribute("data-tmp-url");
          let productID = this.getAttribute("data-tmp-id");
          let productCard = this.closest("product-card");
          if (!productCard) return;
          let productMedia = productCard.querySelector(".product-card__media");
          if (productMedia) {
            let images = productMedia.querySelectorAll("img");
            if (images.length > 0) {
              images[0].src = firstPhoto;
              images[0].removeAttribute("srcset");
            }
            if (images.length > 1) {
              images[1].src = secondPhoto;
              images[1].removeAttribute("srcset");
            }
          }
          let productTitle = productCard.querySelector(".product-title.h6");
          if (productTitle) {
            productTitle.textContent = title;
          }
          let asdasd = productCard.querySelector(".product-card__media");
          if(asdasd) {
            asdasd.href= productURL;
          }
          let asdasdwdasd = productCard.querySelector(".shopify-product-form input[name='id']");
          if(asdasdwdasd) {
            asdasdwdasd.value = productID;
          }
          document.querySelectorAll(".ms-col-swatch a").forEach(a => a.classList.remove("active"));
          this.classList.add("active");
        });
      });

/* ── Carte produit : synchro du swatch avec l'ajout au panier ────────────── */
(function () {
  /* Sur les cartes de collection, chaque coloris est un PRODUIT distinct
     (métachamp custom.variation_products). Le thème met bien à jour l'image et
     les liens quand on clique sur un swatch, mais pas le champ caché
     input[name="id"] du formulaire d'ajout : le panier recevait donc toujours
     la variante du produit rendu en premier. On resynchronise ici l'id de
     variante (et le handle de la modale de choix, le cas échéant) avec le
     swatch réellement sélectionné. */
  function syncCardToSwatch(input) {
    var card = input.closest("product-card");
    if (!card) return;

    var variantId = input.getAttribute("data-variant-id");
    var productUrl = input.getAttribute("data-product-url");

    if (variantId) {
      var idInput = card.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (idInput) idInput.value = variantId;
    }

    /* Modale "choisir les options" : elle charge la page produit à l'ouverture
       depuis son attribut handle, qui doit suivre le coloris sélectionné. */
    var modal = card.querySelector("quick-buy-modal");
    if (modal && productUrl) {
      var handle = productUrl.split("/products/")[1];
      if (handle) modal.setAttribute("handle", handle);
    }

    /* Coloris en rupture : on neutralise le bouton plutôt que de laisser
       partir un ajout au panier qui échouera côté Shopify. */
    var available = input.getAttribute("data-variant-available");
    if (available === null) return;

    var button = card.querySelector(".product-card__quick-add-button");
    var label = button && button.querySelector(".product-card__quick-add-label");
    if (!button) return;

    if (available === "false") {
      button.disabled = true;
      if (label && button.dataset.soldOutLabel) label.textContent = button.dataset.soldOutLabel;
    } else {
      button.disabled = false;
      if (label && button.dataset.addLabel) label.textContent = button.dataset.addLabel;
    }
  }

  /* Délégation sur le document : les cartes sont re-rendues par les filtres et
     le chargement progressif de la collection. */
  document.addEventListener("change", function (event) {
    var input = event.target;
    if (!input || input.type !== "radio") return;
    if (!input.hasAttribute("data-variant-id") && !input.hasAttribute("data-product-url")) return;
    syncCardToSwatch(input);
  });
})();

/* ── Judge.me : masquage des tags "produit acheté" ───────────────────────── */
(function () {
        /* Judge.me réinjecte parfois le tag "produit acheté" avec un style
           plus spécifique que le nôtre dans la popup ouverte au clic sur un
           avis (élément ajouté dynamiquement hors des sections). Le CSS seul
           n'est donc pas fiable : on force le masquage en JS dès que
           l'élément apparaît dans le DOM, où qu'il soit injecté. */
        var jmProductSelectors = [
          ".jdgm-rev__prod-link",
          ".jdgm-rev__br-product-thumbnail",
          ".jdgm-rev__br-product",
          ".jdgm-rev__product-name",
          ".jdgm-product-name",
          ".jdgm-full-rev__product-button",
          ".jdgm-full-rev__product-name",
          ".jdgm-full-rev__prod-link",
          ".jm-product-variant-card"
        ];
        /* Le masquage passe d'abord par le CSS (judgeme-carousel.css). Ce script
           n'est qu'un filet de sécurité pour les éléments réinjectés avec un
           style inline.

           PERF : on ne parcourt plus les mutations une par une. Judge.me insère
           des centaines de nœuds d'affilée en construisant le carrousel, et un
           querySelectorAll par nœud inséré bloquait le thread pendant tout le
           rendu. On se contente d'un seul balayage par frame, et on marque les
           éléments déjà traités pour ne pas réécrire leur style en boucle. */
        var jmSelectorString = jmProductSelectors
          .map(function (selector) { return selector + ":not([data-jm-hidden])"; })
          .join(",");
        var jmScanScheduled = false;

        function hideJmProductTags() {
          jmScanScheduled = false;
          document.querySelectorAll(jmSelectorString).forEach(function (el) {
            el.setAttribute("data-jm-hidden", "");
            el.style.setProperty("display", "none", "important");
          });
        }

        function scheduleJmScan() {
          if (jmScanScheduled) return;
          jmScanScheduled = true;
          requestAnimationFrame(hideJmProductTags);
        }

        hideJmProductTags();

        var jmObserver = new MutationObserver(scheduleJmScan);

        jmObserver.observe(document.documentElement, { childList: true, subtree: true });
      })();
